import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';

// Global text selection on focus for seamless data entry and quick overwrite
document.addEventListener('focusin', (e) => {
  const target = e.target;
  if (!target) return;
  const tag = target.tagName;
  const type = target.type ? target.type.toLowerCase() : '';

  const nonTextTypes = ['button', 'submit', 'checkbox', 'radio', 'file', 'image', 'reset', 'range', 'color'];
  if ((tag === 'INPUT' && !nonTextTypes.includes(type)) || tag === 'TEXTAREA') {
    if (typeof target.select === 'function') {
      setTimeout(() => {
        try {
          if (document.activeElement === target) {
            target.select();
          }
        } catch (err) {
          // ignore unsupported input types
        }
      }, 30);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
